export default __webpack_public_path__ + "locales/hy-AM/Webhooks.json?hash=ab8f211fef56fc4f4235aeaf1c9a8350";